import React, { useEffect, useState } from 'react';
import './Methodologie.css';
import { FaComments, FaLightbulb, FaProjectDiagram, FaChartLine } from 'react-icons/fa';

const phases = [
  {
    id: 1,
    title: 'Phase 1: Phase de contact et compréhension de vos besoins',
    details: [
      "Écoute active de vos attentes et clarification des objectifs de votre projet",
      "Présentation détaillée de notre démarche méthodologique agile et collaborative"
    ],
    icon: <FaComments />,
    color: '#FFD700',
    position: 'top-left'
  },
  {
    id: 2,
    title: 'Phase 2: Co-réflexion et cadrage du projet',
    details: [
      "Diagnostic rapide et synthétique de votre site web et/ou de vos réseaux sociaux",
      "Co-construction et finalisation du cahier des charges selon vos priorités et enjeux"
    ],
    icon: <FaLightbulb />,
    color: '#1E90FF',
    position: 'top-right'
  },
  {
    id: 3,
    title: 'Phase 3: Réalisation du projet en cycles trimestriels',
    details: [
      "Validation commune d'un plan d'action trimestriel, aligné sur vos priorités et votre budget",
      "Co-définition des sprints à réaliser chaque trimestre, avec des livrables précis à chaque étape"
    ],
    icon: <FaProjectDiagram />,
    color: '#FF6347',
    position: 'bottom-right'
  },
  {
    id: 4,
    title: 'Phase 4: Suivi, évaluation continue et ajustements',
    details: [
      "Suivi rigoureux de l'avancement des sprints à l'aide d'indicateurs de performance définis en amont",
      "Réflexion conjointe sur les enseignements tirés à chaque cycle",
      "Ajustement éventuel des priorités, du périmètre ou du budget, selon l'évolution des besoins",
      "Reprise possible aux phases 2 ou 3 pour garantir l'adéquation continue avec vos objectifs"
    ],
    icon: <FaChartLine />,
    color: '#32CD32',
    position: 'bottom-left'
  }
];

const radius = 160;
const iconCircleSize = 50;

const Methodologie = () => {
  const [activePhase, setActivePhase] = useState(null);

  const positionOnCircle = (index, total, radius) => {
    const angle = (360 / total) * index - 90;
    const rad = (angle * Math.PI) / 180;
    return {
      x: radius * Math.cos(rad),
      y: radius * Math.sin(rad),
    };
  };

  const handleIconClick = (phaseId) => {
    setActivePhase(activePhase === phaseId ? null : phaseId);
  };

  return (
    <div className="methodologie-container">
      <div className="methodologie-header">
        <h2>Notre Méthodologie</h2>
        <p>Une approche Agile et Innovante,<br />centrée sur la co-construction</p>
        <p className="instruction-text">Explorez chaque étape de notre méthodologie en cliquant sur les icônes.</p>
      </div>

      <div className="methodologie-content">
        {/* Zone d'affichage des textes */}
        <div className="text-display-area">
          {phases.map((phase) => (
            <div
              key={phase.id}
              className={`phase-text-display ${phase.position} ${
                activePhase === phase.id ? 'active' : ''
              }`}
            >
              <h3 style={{ color: phase.color }}>{phase.title}</h3>
              <ul>
                {phase.details.map((detail, idx) => (
                  <li key={idx}>{detail}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Cercle des icônes centré */}
        <div
          className="icons-circle"
          style={{
            width: radius * 2,
            height: radius * 3,
          }}
        >
          {phases.map((phase, i) => {
            const pos = positionOnCircle(i, phases.length, radius);
            return (
              <div
                key={phase.id}
                className={`icon-circle phase-${phase.id} ${
                  activePhase === phase.id ? 'active' : ''
                }`}
                style={{
                  top: radius + pos.y,
                  left: radius + pos.x,
                  backgroundColor: phase.color + '33',
                  borderColor: phase.color,
                }}
                title={phase.title}
                aria-label={`Phase ${phase.id}: ${phase.title}`}
                onClick={() => handleIconClick(phase.id)}
              >
                <div style={{ color: phase.color, fontSize: '2rem' }}>
                  {phase.icon}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Methodologie;